import React from "react";
import {
  Modal,
  Card,
  Form,
  Typography,
  Flex,
  message,
  Button,
  Row,
  Col,
  Space,
  Input,
  Table,
} from "antd";
import { TbPencilCheck } from "react-icons/tb";
import { SearchOutlined } from "@ant-design/icons";
import { AiFillPlusCircle, AiFillFileText } from "react-icons/ai";
import MyFormManage from "./MyFormManage.jsx";
import { BACKEND_URL_MAIN } from "../../../../utils/util.js";

// import { TableSearchValue } from '../../form';
import InkService from "../../../../service/ERP/Ink.service.js";
import useConfirm from "../../../../store/hook/use-confirm.hook.js";
// import SupplierService from '../../../service/Supplier.service.js';

import { columns } from "./model.js";
// import { useTbSearchContext } from '../../../store/context/table-search.context.js';

import "./MyModal.css";
// import useNotify from '../../../store/hook/use-notification.hook.js';

const inkrequest = InkService();

export default function MyModal({ show, close, values, getContainer = null }) {
  const container = () => document.getElementById("modal-ink-format");
  const inputRef = React.useRef(null);
  // const context = useTbSearchContext();
  const confirms = useConfirm();
  // const notify = useNotify();
  const [form] = Form.useForm();

  const [formManage] = Form.useForm();
  const [openModal, setOpenModal] = React.useState(show);

  const [openFormManage, setOpenFormManage] = React.useState(false);
  const [manageTitle, setManageTitle] = React.useState(false);

  const [mode, setMode] = React.useState("create");

  const [dataSource, setDataSource] = React.useState([]);
  const [fileList, setFileList] = React.useState([]);
  const [dataSelect, setDataSelect] = React.useState({});

  message.config({
    top: 20,
    prefixCls: "my-message",
    getContainer: container,
  });

  const containerStyle = {
    position: "relative",
    overflow: "hidden",
    height: "100%",
  };

  const handleClose = () => {
    setTimeout(() => {
      close(false);
    }, 140);

    //setTimeout( () => close(false), 200 );
  };

  const handleCreatData = () => {
    // setDataSelect({});
    setMode("create");
    setManageTitle("สร้าง - รูปแบบอิงค์");
    setFileList([]);
    formManage.setFieldValue("ink_name", null);
    formManage.setFieldValue("ink_description_1", null);
    formManage.setFieldValue("ink_description_2", null);
    formManage.setFieldValue("ink_description_3", null);
    formManage.setFieldValue("ink_position", null);
    formManage.setFieldValue("ink_color", null);
    formManage.setFieldValue("ink_remark", null);
    formManage.setFieldValue("img_img", []);
    setOpenFormManage(true);
  };

  const handleUpdateData = (record) => {
    // console.log(record);
    setManageTitle("แก้ไข - รูปแบบอิงค์");
    setMode("update");
    setFileList([]);
    formManage.setFieldValue("img_img", []);

    inkrequest
      .get(record?.ink_id)
      .then((res) => {
        const { data, file } = res.data || {};
        if (data) formManage.setFieldsValue(data);

        const inkId = data?.ink_id || record?.ink_id;
        const files = Array.isArray(file) ? file : [];
        const formatted = files.slice(0, 1).map((f) => ({
          img_id: f.img_id,
          uid: f.uid,
          name: f.name,
          status: "done",
          url: `${BACKEND_URL_MAIN}/uploads/ERP/Ink/${inkId}/${f.file_name}`,
        }));

        setFileList(formatted);
        formManage.setFieldValue("img_img", formatted);
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setOpenFormManage(true);
      });
  };

  const handleDeleteData = async (record) => {
    const confirmed = await confirms.confirm({
      title: `ยืนยันการลบรูปแบบอิงค์ ${record.ink_name} ?`,
      okText: "ลบ",
      okType: "danger",
      cancelText: "ยกเลิก",
    });

    if (!confirmed) return; // ผู้ใช้กดยกเลิก ไม่ต้องลบ

    try {
      await inkrequest.deleted(record.ink_id);
      message.success("ลบข้อมูลเรียบร้อยแล้ว");
      setDataSource([]);
      handleSearch();
    } catch (e) {
      console.log(e);
      message.error("ลบข้อมูลไม่สำเร็จ");
    }
  };

  const handleSubmit = async () => {
    try {
      const val = await formManage.validateFields();

      const { record } = dataSelect;
      const fileItem =
        Array.isArray(val?.img_img) && val.img_img.length > 0
          ? val.img_img[0]
          : null;
      const hasNewFile = !!fileItem?.originFileObj;
      /* เคยมีรูปเก็บไว้ใน DB หรือไม่ (fileList คือรูปที่โหลดมาตอนกดแก้ไข) */
      const hadOldFile = Array.isArray(fileList) && fileList.length > 0;
      /* ผู้ใช้กดถังขยะลบรูปเดิมออก แล้วไม่ได้เลือกรูปใหม่ → ต้องสั่งลบที่ฝั่ง server ด้วย */
      const removeImg = mode === "update" && hadOldFile && !fileItem ? 1 : 0;

      const data = {
        ...record,
        ...val,
        remove_img: removeImg,
        ink_id: mode === "update" ? formManage.getFieldValue?.("ink_id") : null,
      };

      const action = mode === "update" ? inkrequest.update : inkrequest.create;
      const actionRes = await action(data);

      const createdInkId =
        mode === "update"
          ? data.ink_id
          : actionRes?.data?.data?.ink_id || actionRes?.data?.ink_id;

      const inkIdToUpload = createdInkId;

      if (hasNewFile && inkIdToUpload) {
        const fd = new FormData();
        fd.append("ink_id", inkIdToUpload);
        if (fileItem?.uid) fd.append("uid", fileItem.uid);
        fd.append("file", fileItem.originFileObj);
        try {
          await inkrequest.uploadPic(fd, { ignoreLoading: true });
        } catch (uploadErr) {
          console.log(uploadErr);
          message.warning("อัปโหลดรูปภาพไม่สำเร็จ แต่ข้อมูลถูกบันทึกแล้ว");
        }
      }

      // clear selected image after save
      formManage.setFieldValue("img_img", []);
      setFileList([]);

      setDataSource([]);
      handleSearch();
      setOpenFormManage(false);
    } catch (e) {
      console.log(e);
      message.error("เกิดข้อผิดพลาด ทำรายการไม่สำเร็จ");
    }
  };

  const handleSearch = React.useCallback((value) => {
    const keyword = typeof value === "string" ? value : "";
    const parm = { ink_name: keyword, p: "search" };

    try {
      inkrequest
        .search(parm, { ignoreLoading: true })
        .then((res) => {
          // const { data, file } = res.data;
          const { data } = res.data;
          setDataSource(data);

          // let fileurl = file.map((data) => ({
          //   ...data,
          //   file_name:
          //     `${BACKEND_URL_MAIN}/uploads/ERP/ink/` +
          //     form.getFieldValue("ink_id") +
          //     "/" +
          //     data.file_name,
          // }));
          // const formattedFileList = fileurl.map((data) => ({
          //   img_id: data.img_id,
          //   uid: data.uid,
          //   name: data.name,
          //   status: "done",
          //   url: data.file_name,
          // }));
          // setFileList(formattedFileList);
          // form.setFieldsValue({ prod_img: formattedFileList });
        })
        .catch((e) => {
          console.log(e);
          message.error("เกิดข้อผิดพลาดในการดึงข้อมูล");
        });
    } catch (err) {
      message.error("เกิดข้อผิดพลาด");
    }
  }, []);

  React.useEffect(() => {
    handleSearch();
  }, [handleSearch]);

  React.useEffect(() => {
    const initeil = async () => {
      // console.log( 4444)
    };
    initeil();

    return () => {};
  }, []);

  // React.useEffect(() => {
  //     console.log( dataSelect, new Date() )
  // }, [dataSelect]);

  const modalTitle = (
    <>
      <Flex align="center" gap={4}>
        <AiFillFileText style={{ fontSize: "1rem" }} />
        <Typography.Text className="ms-1 mb-0">
          รายการรูปแบบอิงค์
        </Typography.Text>
      </Flex>
    </>
  );

  const modalSearch = (
    <>
      <Row
        gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
        className="m-0"
      >
        <Col xs={24} sm={24} lg={24}>
          <Form.Item label="ค้นหา">
            <Input
              ref={inputRef}
              suffix={<SearchOutlined />}
              onChange={(e) => {
                handleSearch(e.target.value);
              }}
              placeholder="ค้นหาชื่อ หรือ รหัส"
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );

  const modalFooter = (
    <>
      <Row>
        <Col span={24}>{/* Ignore */}</Col>
        <Col span={24}>
          <Flex justify="flex-end">
            {openFormManage ? (
              <>
                <Button
                  className="bn-center bn-success-outline min-w-36"
                  icon={<TbPencilCheck />}
                  onClick={() => handleSubmit()}
                >
                  ยืนยัน/บันทึก
                </Button>
              </>
            ) : (
              <>
                {/* <Button
                  className="bn-center bn-primary  min-w-36"
                  icon={<TbCheck />}
                  onClick={() => handleChoosed()}
                  disabled={!dataSelect?.record?.payment_name}
                >
                  ยืนยันการเลือก
                </Button> */}
              </>
            )}
          </Flex>
        </Col>
      </Row>
    </>
  );

  const TitleTable = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
            List of Ink Format
          </Typography.Title>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          <Col span={12} style={{ display: "flex", justifyContent: "end" }}>
            <Button
              className="bn-success-outline"
              size="default"
              style={{ display: "flex", alignItems: "center" }}
              icon={
                <AiFillPlusCircle
                  style={{
                    fontSize: "1.15rem",
                    marginRight: 4,
                    verticalAlign: "middle",
                    marginBottom: 2,
                  }}
                />
              }
              onClick={() => handleCreatData()}
            >
              Create Ink Format
            </Button>
          </Col>
        </Flex>
      </Col>
    </Flex>
  );

  const handleChoose = (value) => {
    setDataSelect((s) => ({ ...s, value }));
    values(value);
    setTimeout(() => {
      close(false);
    }, 140);
  };

  const column = columns({ handleChoose, handleUpdateData, handleDeleteData });

  return (
    <>
      <div className="modal-suppliers" id="modal-area">
        <Modal
          open={openModal}
          title={modalTitle}
          afterClose={() => handleClose()}
          onCancel={() => setOpenModal(false)}
          maskClosable={false}
          style={{ top: 20, height: "calc(100vh - 10px)" }}
          width={1200}
          className="modal-loading-type modal-ink-format add-footer"
          footer={modalFooter}
          getContainer={() =>
            !!getContainer && typeof getContainer === "function"
              ? getContainer()
              : document.body
          }
        >
          <div style={containerStyle} id="modal-ink-format">
            <Space
              direction="vertical"
              size="middle"
              style={{ display: "flex", position: "relative" }}
              className="current h-full"
            >
              <Card style={{ backgroundColor: "#f0f0f0" }}>
                <Form form={form} layout="vertical" autoComplete="off">
                  {modalSearch}
                </Form>
              </Card>
              <Card style={{ height: "100%" }}>
                <Table
                  title={() => TitleTable}
                  size="small"
                  rowKey="ink_code"
                  columns={column}
                  dataSource={dataSource}
                />
              </Card>
            </Space>
            {openFormManage && (
              <MyFormManage
                form={formManage}
                show={openFormManage}
                close={async () => {
                  setOpenFormManage(false);
                  formManage.resetFields();
                }}
                source={dataSelect}
                img={fileList}
                title={manageTitle}
              />
            )}
          </div>
        </Modal>
      </div>
    </>
  );
}
